import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CryptoTicker from "../components/Trading/CryptoTicker";

const PRIMARY_BLUE = "#0B5ED7";
const PRIMARY_BLUE_HOVER = "#0A58CA";
const GREEN = "#177245";            // verde elegante
const GREEN_BG = "#EAF3EE";
const RED = "#B42318";
const RED_BG = "#FDECEC";

const WalletProfile = () => {
  const navigate = useNavigate();
  const [hoveredButtons, setHoveredButtons] = useState({});

  // Texto descriptivo por módulo
  const descriptions = {
    "videos": "Clases grabadas y demostraciones con ejemplos prácticos.",
    "coming-soon": "Módulo en preparación. Muy pronto disponible para todos los alumnos.",
   // "bootcamps": "Programas intensivos con prácticas reales y mentoría especializada.",
    "books": "Selección curada de libros para fortalecer tu base técnica y estratégica.",
    "simuladores": "Laboratorios y simulaciones para entender procesos de blockchain paso a paso.",
    //"videos": "Clases grabadas y demostraciones con ejemplos prácticos.",
    "historia-del-dinero": "De la sal y el oro al dinero digital: contexto histórico esencial.",
    "blockchain-en-la-industria": "Casos de uso en logística, finanzas, salud y más.",
    "bitcoin-historia": "Por qué Bitcoin cambió el concepto de valor y confianza.",
    "criptomonedas-y-tokens": "Diferencias clave, utilidades y modelos de token.",
    "mineria-blockchain": "Prueba de trabajo, dificultad, recompensas y costos.",
    "criptografia-blockchain": "Hashing, firmas digitales y pruebas de integridad.",
    "criptografia-asimetrica": "Claves públicas/privadas y su aplicación en transacciones.",
    "explorando-hash-sha256": "Cómo funciona SHA-256 y por qué es fundamental.",
    "arboles-merkle-blockchain": "Estructuras para verificar datos a gran escala.",
    "introduccion-wallets-blockchain": "Tipos de wallets, seguridad y mejores prácticas.",
    "nft-blockchain": "Propiedad digital, coleccionables y casos de negocio.",
    "contratos-inteligentes": "Automatización de reglas y lógica en la cadena.",
    "desarrollo-dapps-blockchain": "Arquitectura, herramientas y despliegue de DApps.",
    "aspectos-legales-blockchain": "Regulación, cumplimiento y riesgos legales.",
    "finanzas-descentralizadas-defi": "Préstamos, AMMs, yield y modelos de gobernanza."
  };

  // Estilos
  const styles = {
    root: {
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "#ffffff",
      marginTop: "10vh",
    },
    serif: `
      .serif-root, .serif-root * {
        font-family: Georgia, "Times New Roman", Times, serif;
        letter-spacing: 0.01em;
      }
    `,
    legendWrap: {
      width: "95%",
      maxWidth: 1200,
      display: "flex",
      justifyContent: "flex-end",
      gap: 16,
      marginBottom: 8,
    },
    legend: { display: "flex", alignItems: "center", gap: 8, color: "#374151", fontSize: 14 },
    dot: (color) => ({ width: 10, height: 10, borderRadius: "50%", background: color, display: "inline-block" }),

    containerCard: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "95%",
      padding: "20px",
      gap: "20px",
      flexWrap: "wrap",
      maxWidth: 1200,
    },

    courseCard: {
      position: "relative",
      width: 300,
      height: 420,
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: 0,             // sin radios
      padding: 20,
      textAlign: "center",
      boxShadow: "0 1px 2px rgba(0,0,0,.05)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease",
    },
    courseCardHover: {
      transform: "translateY(-2px)",
      borderColor: "#cbd5e1",
      boxShadow: "0 8px 24px rgba(0,0,0,.08)",
    },
    statusPill: (active) => ({
      position: "absolute",
      top: 10,
      left: 10,
      padding: "6px 10px",
      borderRadius: 0,             // sin radios
      background: active ? GREEN_BG : RED_BG,
      color: active ? GREEN : RED,
      fontWeight: 700,
      fontSize: 12,
      border: `1px solid ${active ? GREEN : RED}`,
      display: "flex",
      alignItems: "center",
      gap: 8,
    }),
    statusDotSmall: (color) => ({ width: 8, height: 8, background: color, borderRadius: "50%" }),

    courseCardImage: {
      width: "100%",
      height: 180,
      borderRadius: 0,
      objectFit: "cover",
      border: "1px solid #eef2f7",
      background: "#f3f4f6",
    },
    courseCardText: {
      fontSize: 18,
      color: "#111827",
      margin: "12px 0 4px",
      fontWeight: 700,
      lineHeight: 1.25,
    },
    courseCardDesc: {
      fontSize: 14,
      color: "#4b5563",
      margin: "0 0 10px",
      lineHeight: 1.35,
      flexGrow: 1,
    },
    button: (active, hovered) => ({
      padding: "10px 20px",
      borderRadius: 0,                        // sin radios
      fontWeight: 700,
      cursor: "pointer",
      width: "100%",
      border: `1px solid ${active ? (hovered ? PRIMARY_BLUE_HOVER : PRIMARY_BLUE) : "#9CA3AF"}`,
      backgroundColor: active ? (hovered ? PRIMARY_BLUE_HOVER : PRIMARY_BLUE) : "#F3F4F6",
      color: active ? "#ffffff" : "#6B7280",
      transition: "background-color .15s ease, border-color .15s ease",
    }),
  };

  // Cursos (si id === "coming-soon" => inactivo)
  const courses = [
    { id: "clases", name: "Clases Grabadas y Guia de estudio", img: "https://raw.githubusercontent.com/AppsDevsLeon/Revista_blockchain/refs/heads/main/imagenes/-a-futuristic-3d-rendered-visualization-of-blockch.png" },
    { id: "mint-certificate", name: "Genera tu certificado y mintealo", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/2.png" },
    { id: "diccionario", name: "Diccionario: Conceptos sobre Bitcoin & Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ChatGPT%20Image%206%20ago%202025%2C%2007_46_13.png" },
    { id: "fame-projects", name: "Proyectos Destacados (FAME Projects)", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/3.png" },
    { id: "quiz", name: "Quiz", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/5.png" },
    { id: "CDB", name: "Curso Dominando el Blockchain ", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/8.png" },
  //  { id: "bootcamps", name: "Bootcamps 2025", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ChatGPT%20Image%201%20jun%202025%2C%2003_44_19.png" },
    { id: "books", name: "Biblioteca de Libros", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/4.png" },
    { id: "simuladores", name: "Simulaciones Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/7.png" },
    { id: "coming-soon", name: "Simulador de Trading", img: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/ImagesProfile/6.png" },
    { id: "historia-del-dinero", name: "Historia del dinero", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(4).gif" },
    { id: "blockchain-en-la-industria", name: "Blockchain en la Industria", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(2).gif" },
    { id: "bitcoin-historia", name: "Bitcoin: Un Antes y un Después en la Historia del Dinero", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(3).gif" },
    { id: "criptomonedas-y-tokens", name: "Criptomonedas y Tokens", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(5).gif" },
    { id: "mineria-blockchain", name: "Minería del Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(1).gif" },
    { id: "criptografia-blockchain", name: "Criptografía en Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(3).gif" },
    { id: "criptografia-asimetrica", name: "Criptografía Asimétrica y las Claves Públicas y Privadas", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(5).gif" },
    { id: "explorando-hash-sha256", name: "Explorando Hash y SHA-256", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(2).gif" },
    { id: "arboles-merkle-blockchain", name: "Árboles de Merkle en Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(1).gif" },
    { id: "introduccion-wallets-blockchain", name: "Introducción a Wallets con Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(3).gif" },
    { id: "nft-blockchain", name: "NFT en Blockchain", img: "https://moneymorning.com/wp-content/blogs.dir/1/files/2021/04/shutterstock_1936167706-featured.jpg" },
    { id: "contratos-inteligentes", name: "Contratos Inteligentes", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(5).gif" },
    { id: "desarrollo-dapps-blockchain", name: "Desarrollo de DApps: Creando Aplicaciones en la Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(3).gif" },
    { id: "aspectos-legales-blockchain", name: "Aspectos Legales y Regulatorios del Blockchain", img: "https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/1%20(1).gif" },
    { id: "finanzas-descentralizadas-defi", name: "Finanzas Descentralizadas (DeFi): Beneficios y Utilidades", img: "https://cdn.mos.cms.futurecdn.net/9EieB365kjRPqo9kL2TWBg.jpg" },
  ];

  const isActive = (id) => id !== "coming-soon";

  const handleCourseClick = (courseId, active) => {
    if (!active) {
      window.alert("Este módulo aún NO está activo. Muy pronto estará disponible 👀");
      return;
    }
    // navegación con ligero delay (si lo quieres mantener)
    setTimeout(() => navigate(`/course/${courseId}`), 500);
  };

  return (
    <div className="serif-root" style={styles.root}>
      {/* Tipografía serif */}
      <style>{styles.serif}</style>

      <CryptoTicker />

      {/* Leyenda de estados */}
      <div style={styles.legendWrap}>
        <div style={styles.legend}>
          <span style={styles.dot(GREEN)}></span> Activo
        </div>
        <div style={styles.legend}>
          <span style={styles.dot(RED)}></span> No activo
        </div>
      </div>

      {/* Grid de cartas */}
      <div style={styles.containerCard}>
        {courses.map((course) => {
          const hover = !!hoveredButtons[course.id];
          const active = isActive(course.id);

          return (
            <div
              key={course.id}
              style={{ 
                ...styles.courseCard,
                ...(hover ? styles.courseCardHover : {})
              }}
              onMouseEnter={() => setHoveredButtons((p) => ({ ...p, [course.id]: true }))}
              onMouseLeave={() => setHoveredButtons((p) => ({ ...p, [course.id]: false }))}
              aria-label={`${course.name} - ${active ? "Activo" : "No activo"}`}
            >
              {/* Indicador de estado */}
              <div style={styles.statusPill(active)}>
                <span style={styles.statusDotSmall(active ? GREEN : RED)} />
                {active ? "Activo" : "No activo"}
              </div>

              <img src={course.img} alt={course.name} style={styles.courseCardImage} />

              <h3 style={styles.courseCardText}>{course.name}</h3>
              <p style={styles.courseCardDesc}>
                {descriptions[course.id] || "Contenido formativo para avanzar de forma sólida y práctica."}
              </p>

              <button
                style={styles.button(active, hover)}
                onClick={() => handleCourseClick(course.id, active)}
                aria-disabled={!active}
              >
                Ir a módulos
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WalletProfile;
